// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Loader_Loader__1Yoww"};